import { Loading } from '@bumble/app/components/Loading';
import { getChartTime, getTooltipLabel } from '@bumble/app/utils/get-date';
import { PureComponent } from 'react';
import {
  CartesianGrid,
  Line,
  LineChart as LineChartRecharts,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';

const chartColors = ['#1F2848', '#1E8497', '#B3A689', '#BC9777', '#D3782B'];

interface ChartData {
  time: string;
  value: number;
}
interface LineChartProps {
  data: ChartData[];
  label: string;
  loading?: boolean;
  hours?: number;
  percentage?: boolean;
}
export default class LineChart extends PureComponent<LineChartProps> {
  // eslint-disable-next-line react/static-property-placement
  static defaultProps = {
    loading: false,
  };

  render() {
    const { data, label, loading, hours = 0, percentage } = this.props;

    if (loading) return <Loading height={280} />;
    return (
      <ResponsiveContainer width="100%" height={200}>
        <LineChartRecharts
          width={500}
          height={300}
          margin={{
            top: 5,
            right: 30,
            left: 20,
            bottom: 5,
          }}
          data={data}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis
            dataKey="time"
            type="category"
            allowDuplicatedCategory={false}
            tickFormatter={(x) => getChartTime(x, hours)}
          />
          <YAxis
            orientation="left"
            dataKey="value"
            type="number"
            width={30}
            domain={percentage ? [0, 100] : undefined}
            tickFormatter={(value) =>
              new Intl.NumberFormat('en-US', {
                notation: 'compact',
                compactDisplay: 'short',
              }).format(value)
            }
          />
          <Tooltip
            labelFormatter={(l) => getTooltipLabel(l)}
            formatter={(v) =>
              v.toLocaleString('en-US', {
                minimumFractionDigits: 0,
              })
            }
          />
          <Line stroke={chartColors[0]} dot={false} dataKey="value" name={label} />
        </LineChartRecharts>
      </ResponsiveContainer>
    );
  }
}
